import { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, useNavigate } from 'react-router-dom';
import Dashboard from './components/Dashboard'
import Login from './components/Login'
import Logout from './components/Logout'
import { useAuth0 } from "@auth0/auth0-react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCarTunnel, faX, faEllipsis, faUser } from '@fortawesome/free-solid-svg-icons';
import { Table, Dropdown, Nav, Navbar, OverlayTrigger, Popover } from 'react-bootstrap';
import { setFetchAccessTokenFunc, getMe } from './utils/api';
import { setLogoutFunc } from './utils/navigation';
import Metrics from './components/Metrics';
import Users from './components/Users';
import Transactions from './components/Transactions';
import Assets from './components/Assets';
import Discover from './components/Discover';
import 'bootstrap/dist/css/bootstrap.min.css';
import BusinessPartners from './components/BusinessPartners';
import Rules from './components/Rules';
import Entities from './components/Entities';
import { useDataStore } from './Store';
import Roles from './components/Roles';
import { ReactComponent as Logo } from './logo.svg';

function App() {
  
  const { getAccessTokenSilently, logout, getIdTokenClaims, isLoading } = useAuth0();
  setFetchAccessTokenFunc(getAccessTokenSilently);
  setLogoutFunc(logout);

  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const user = useDataStore((state) => state.user);


  return (
    <>
      <Navbar expand="lg" bg="dark" data-bs-theme="dark" className="px-2">
        <Navbar.Brand>
          <Logo style={{ width: 20, height: 30, marginRight: 3, marginTop: -4 }} />
          Steadly.io
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <OverlayTrigger show={show} placement="bottom" rootClose={false} onHide={() => setShow(false)} overlay={
              <Popover id="popover-positioned-bottom" style={{ whiteSpace: 'nowrap', width: 'auto', minWidth: '250px', maxWidth: '500px' }}>
                <div style={{ paddingTop: 5, paddingRight: 10, textAlign: 'right' }}><FontAwesomeIcon icon={faX} style={{ cursor: 'pointer' }} onClick={() => setShow(false)} /></div>
                {user && (
                  <>
                    <div style={{ padding: 10 }}>
                      <div className="fw-bold ">{user?.FirstName} {user?.LastName}</div>
                      <div className="text-muted small mb-2">Name</div>
                  
                      <div className="fw-bold ">{user?.Email}</div>
                      <div className="text-muted small mb-2">Email</div>

                      <div className="fw-bold ">{user?.ExternalId}</div>
                      <div className="text-muted small mb-2">External ID</div>

                      <div className="fw-bold ">{user?.Role}</div>
                      <div className="text-muted small">Role</div>
                    </div>
                  </>
                )}
                <hr />
                <p onClick={() => {
                  setShow(false);
                  navigate('/logout');
                }} style={{ cursor: 'pointer', fontWeight: 'bold', textAlign: 'center' }}>
                  Sign out
                </p>
              </Popover >
            } popperConfig={{
              modifiers: [
                {
                  name: 'preventOverflow',
                  options: {
                    boundary: 'viewport',
                    padding: 10,
                  },
                },
              ],
            }}
            >
              <FontAwesomeIcon icon={faUser} style={{ marginRight: 10, cursor: 'pointer' }} size="lg" color="white" onClick={() => setShow(true)} />
            </OverlayTrigger >
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      <Routes>
        <Route path='/' element={<Dashboard />} >
          <Route index element={<Metrics />} />
          <Route path='discover' element={<Discover />} />
          <Route path='users' element={<Users />} />
          <Route path='businessPartners' element={<BusinessPartners />} />
          <Route path='assets' element={<Assets />} />
          <Route path='transactions' element={<Transactions />} />
          <Route path='rules' element={<Rules />} />
          <Route path='roles' element={<Roles />} />
          <Route path='entities' element={<Entities />} />
        </Route>
        <Route path="/login" element={<Login />} />
        <Route path="/logout" element={<Logout />} />
      </Routes>
    </>
  );
}

export default App;